import SmartTableWithSearchBox from './SmartTableWithSearchBox';

export default SmartTableWithSearchBox;
